import { Container, Grid } from '@material-ui/core'
import React, { useEffect, useMemo, useState } from 'react'
import { ButtonHLPure } from '../../pures'
import { RadioGroup } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';

const UserAdministrationUserRoles = (props) => {
    const { t, selectedUser, roles, handleBack, isEditing, setIsEditing, updateUserRoles } = props;
    const { t: tCommon } = useTranslation('common')
    const [selectedRoles, setSelectedRoles] = useState({})

    const mapUserRoles = () => {
        let userRoles = {}
        // For each role group, check what role the user already has
        for (let i = 0; i < roles.length; i++) {
            const roleGroup = roles[i];
            const thisGroupRoles = roleGroup.roles.map(role => role.id);

            const userRole = selectedUser.roles.find(role => thisGroupRoles.includes(role.id))
            userRoles[roleGroup.groupName] = userRole ? userRole.id : null
        }
        setSelectedRoles(userRoles)
    }

    useEffect(() => {
        mapUserRoles()
    }, [selectedUser, roles])

    const generalRoles = useMemo(() => roles.find(group => group.groupName === 'general'), [roles])

    const handleChange = (e, groupName) => {
        const value = +e.value
        setSelectedRoles(prev => ({ ...prev, [groupName]: value }))
    }

    const toggleEdit = (value) => {
        if (!value) {
            mapUserRoles()
        }
        setIsEditing(value)
    }

    const handleSave = async () => {
        try {
            await updateUserRoles(Object.values(selectedRoles))
            setIsEditing(false)
        } catch (_) { }
    }

    return (
        <Container maxWidth={"md"}>
            <Grid container>
                <Grid item xs={12}>
                    <RadioGroup
                        name="general"
                        value={selectedRoles['general']}
                        onChange={(e) => handleChange(e, 'general')}
                        data={generalRoles.roles.map(role => ({ label: t(role.key), value: role.id }))}
                        disabled={!isEditing}
                    />
                </Grid>

                {
                    roles.map(group => {
                        if (group.groupName === 'general') return null;

                        const data = group.roles.map(role => ({ label: t(role.key), value: role.id }))

                        return <Grid key={group.moduleId} item xs={12}>
                            <h3>{t(group.groupName)}</h3>
                            <RadioGroup
                                data={data}
                                onChange={(e) => handleChange(e, group.groupName)}
                                value={selectedRoles[group.groupName]}
                                name={group.groupName}
                                disabled={!isEditing}
                            />
                        </Grid>
                    })
                }
            </Grid>

            <div className="button-actions">
                {
                    isEditing
                        ? <>
                            <ButtonHLPure colorScheme="error" outlined onClick={() => toggleEdit(false)} nameBtn={tCommon("cancel")} />
                            <ButtonHLPure primary nameBtn={tCommon("save")} onClick={handleSave} />
                        </>
                        : <>
                            <ButtonHLPure primary outlined onClick={handleBack} nameBtn={tCommon("goBack")} />
                            <ButtonHLPure primary onClick={() => toggleEdit(true)} nameBtn={tCommon("edit")} />
                        </>
                }
            </div>
        </Container>
    )
}

export default UserAdministrationUserRoles